import { defineStore } from 'pinia';
import router from '@/router';

const useNavStore = defineStore('nav', {
    state: () => ({
        basePage: null,
        page: null,
        scrollPositions: {},
        menu: [
            {
                link: '/users',
                name: 'users',
                title: 'nav.users',
                permission: ['admin', 'playlist_curator', 'artist_curator'],
                pages: ['users']
            }, {
                link: '/roles',
                name: 'roles',
                title: 'nav.roles',
                permission: ['admin'],
                pages: ['roles']
            }, {
                link: '/categories',
                name: 'categories',
                title: 'nav.categories',
                permission: ['dictionary_curator'],
                pages: ['categories']
            }, {
                link: '/genres',
                name: 'genres',
                title: 'nav.genres',
                permission: ['dictionary_curator'],
                pages: ['genres']
            }, {
                link: '/instruments',
                name: 'instruments',
                title: 'nav.instruments',
                permission: ['dictionary_curator'],
                pages: ['instruments']
            }, {
                link: '/moods',
                name: 'moods',
                title: 'nav.moods',
                permission: ['dictionary_curator'],
                pages: ['moods']
            }, {
                link: '/tags',
                name: 'tags',
                title: 'nav.tags',
                permission: ['dictionary_curator'],
                pages: ['tags']
            }, {
                link: '/licenses',
                name: 'licenses',
                title: 'nav.licenses',
                permission: ['track_curator'],
                pages: ['licenses']
            }, {
                link: '/artists',
                name: 'artists',
                title: 'nav.artists',
                permission: ['artist_curator', 'track_curator', 'artist'],
                pages: ['artists']
            }, {
                link: '/tracks',
                name: 'tracks',
                title: 'nav.tracks',
                permission: ['track_curator'],
                pages: ['tracks']
            }, {
                link: '/releases',
                name: 'releases',
                title: 'nav.releases',
                permission: ['track_curator'],
                pages: ['releases']
            }, {
                link: '/playlists',
                name: 'playlists',
                title: 'nav.playlists',
                permission: ['playlist_curator'],
                pages: ['playlists']
            }, {
                link: '/showcase',
                name: 'showcase',
                title: 'nav.showcase',
                permission: ['showcase_curator'],
                pages: ['showcase']
            }
        ]
    }),
    getters: {
        menuItemIsActive: (state) => (name) => state.basePage === name
    },
    actions: {
        setPage(name) {
            this.page = name;
            this.basePage = this.menu.find(item => item.name === name || item.pages.indexOf(name) !== -1)?.name || this.basePage || this.menu[0].name;
        },
        open(name) {
            delete this.scrollPositions[name];

            this.setPage(name);
            router.push({ name });
        },
        back() {
            const data = this.menu.find(item => item.pages.indexOf(this.page) !== -1);

            router.back(data?.name);
        },
        ready(page) {
            if (page !== this.page) {
                return;
            }
        }
    }
});

export default useNavStore;
